import { useEffect, useRef } from 'react';
import { useWallet } from '../context/WalletContext';

// Triggers a silent network switch ONCE per mismatch.
// Will not loop because we track last-attempted chainId.
export const useNetworkGuard = () => {
  const { account, chainId, networkOk, switchNetwork, targetChainId } = useWallet();
  const triedRef = useRef(null);

  useEffect(() => {
    if (!account) return;
    if (networkOk) {
      triedRef.current = null;
      return;
    }
    if (chainId == null) return;
    if (triedRef.current === chainId) return; // already attempted for this chain
    triedRef.current = chainId;
    switchNetwork();
  }, [account, chainId, networkOk, switchNetwork, targetChainId]);
};
